import {LinkProps} from 'next/link';
import {APP_ROUTES_TO_URL, DISCOUNT_ROUTE} from 'core/modules/routing/constants';

const NEXT_PATH_LIST = [
    APP_ROUTES_TO_URL.addresses,
    APP_ROUTES_TO_URL.brands,
    APP_ROUTES_TO_URL.articles,
    APP_ROUTES_TO_URL.catalog,
    APP_ROUTES_TO_URL.events,
    `${APP_ROUTES_TO_URL.personal}${APP_ROUTES_TO_URL.wishlist}`,
    APP_ROUTES_TO_URL.wishlist,
    `${APP_ROUTES_TO_URL.stock}/`,
    APP_ROUTES_TO_URL.stock,
    '/search',
    DISCOUNT_ROUTE,
] as const;

const EXCLUDED_PATH_LIST: string[] = [];

const articlesTestsXRouteRegex = /\/articles\/tests\/.+/u;

export const checkIsNextPath = (href: LinkProps['href']) => {
    const hrefString = String(href);

    const isExcludedPath = EXCLUDED_PATH_LIST.some((path) => hrefString.includes(path));
    const isArticlesTestsXRoute = articlesTestsXRouteRegex.test(hrefString);
    const isHomePageRoute = APP_ROUTES_TO_URL.main === hrefString;

    if (isExcludedPath || isArticlesTestsXRoute) {
        return false;
    }

    return NEXT_PATH_LIST.some((path) => hrefString.includes(path)) || isHomePageRoute;
};
